import { h } from 'preact';
import { Text } from 'preact-i18n';

import { DIVISIONS, CATEGORIES, POWER_FACTORS, divisionAllowsMajor } from '../../lib/ipsc';

/*
 * The three IPSC signup selects (division / power factor / category), shared by
 * the signup page, the convention signup box and the participant drawer so the
 * option lists live in exactly one place (lib/ipsc.js).
 *
 * Props: { division, powerFactor, ipscCategory, onChange(name, value), extra? }
 * `extra` = attributes spread onto every <select> (e.g. data-field for editArrayObject).
 */
export default function IpscSignupFields({
    division = '', powerFactor = 'minor', ipscCategory = '', onChange = () => {}, extra = {},
}) {
    const majorAllowed = divisionAllowsMajor(division);
    const onInput = e => onChange(e.target.name, e.target.value);
    return (<>
        <div class='d-flex flex-column mt-3'>
            <span class='text-body-secondary font-weight-light'>
                <Text id='ipsc.division'>Division</Text>
            </span>
            <select class='form-control rounded-pill' name='class' value={division} onInput={onInput} {...extra}>
                <option value=''>-- <Text id='ipsc.choose-division'>Choose division</Text> --</option>
                {DIVISIONS.map(d => <option key={d.key} value={d.key}>{d.label}</option>)}
            </select>
        </div>
        <div class='d-flex flex-column mt-3'>
            <span class='text-body-secondary font-weight-light'>
                <Text id='ipsc.power-factor'>Power factor</Text>
            </span>
            <select class='form-control rounded-pill' name='powerFactor' value={majorAllowed ? powerFactor : 'minor'} onInput={onInput} {...extra}>
                {POWER_FACTORS.map(pf => (
                    <option key={pf} value={pf} disabled={pf === 'major' && !majorAllowed}>
                        {pf === 'major' ? 'Major' : 'Minor'}
                    </option>
                ))}
            </select>
            {!majorAllowed && division && (
                <small class='text-body-secondary mt-1'>
                    <Text id='ipsc.minor-only'>This division is scored Minor only.</Text>
                </small>
            )}
        </div>
        <div class='d-flex flex-column mt-3'>
            <span class='text-body-secondary font-weight-light'>
                <Text id='ipsc.category'>Category</Text>
            </span>
            <select class='form-control rounded-pill' name='ipscCategory' value={ipscCategory} onInput={onInput} {...extra}>
                {CATEGORIES.map(c => <option key={c.key || 'none'} value={c.key}>{c.label}</option>)}
            </select>
        </div>
    </>);
}
